
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2026_18607)"}},[_c('path',{attrs:{"d":"M20 5.344H4.625V1.609c0-.5.406-.906.906-.906h13.547c.5 0 .906.406.906.906v3.735H20z","fill":"#41A5ED"}}),_c('path',{attrs:{"d":"M20 5.344H4.625V10H20V5.344z","fill":"#2C7BD5"}}),_c('path',{attrs:{"d":"M20 10H4.625v4.656H20V10z","fill":"#195ABE"}}),_c('path',{attrs:{"d":"M19.094 19.297H5.547a.907.907 0 01-.906-.906v-3.735H20v3.735c0 .5-.406.906-.906.906z","fill":"#103E91"}}),_c('path',{attrs:{"d":"M9.297 15.078H1.016c-.547 0-1-.453-1-1V5.922c0-.547.453-1 1-1h8.28c.548 0 1 .453 1 1v8.156c0 .547-.437 1-1 1z","fill":"#2166C3"}}),_c('path',{attrs:{"d":"M3.016 12.875l-1.391-5.61h1.11l.546 2.548c.14.687.281 1.39.375 1.953h.016c.094-.594.25-1.25.406-1.97l.61-2.53H5.78l.563 2.578c.14.672.265 1.281.343 1.89h.016c.094-.625.234-1.25.39-1.937l.595-2.531H8.75l-1.531 5.609H6.094l-.594-2.64c-.14-.626-.25-1.157-.328-1.766h-.016a16.54 16.54 0 01-.375 1.781l-.656 2.64h-1.11v-.015z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".2","d":"M10.297 5.828v8.25c0 .547-.453 1-1 1H4.64v.89h5.5c.546 0 1-.452 1-1V6.814c0-.5-.36-.922-.844-.985z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2026_18607"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    